import { render, staticRenderFns } from "./m-certificado.vue?vue&type=template&id=ce410572&"
import script from "./m-certificado.vue?vue&type=script&lang=js&"
export * from "./m-certificado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports